// extracted by mini-css-extract-plugin
export default {"profile-wrapper":"ProfileDisplay_profile-wrapper__Uc0pf","row":"ProfileDisplay_row__++fS7","photo":"ProfileDisplay_photo__x01-U"};